/* @ngInject */
export default function TripWireService($q, $sails, $log, EventInfoService) {
  const service = this;

  service.dismissAllEvents = dismissAllEvents;
  service.getDismissableEventsFromOneDayAgo = getDismissableEventsFromOneDayAgo;
  service.getEventsDetailed = getEventsDetailed;

  // exclusive to tripwires for now but should eventually be added to Events Service
  function dismissAllEvents(equipmentId) {
    return EventInfoService.dismissAllEventsByEquipment(equipmentId);
  }

  function getDismissableEventsFromOneDayAgo(equipmentIds) {
    return $sails.get(`/event/countTripwireTrips/${equipmentIds.join('|')}`)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function getEventsDetailed(equipmentId) {
    return $sails.get(
      `/event/byequipment/${equipmentId}?eventName=tripwires/tripped&dismissed=false&maxQueryDateRange=1`
    )
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }
}
